import { MakerData, Position } from "../types/type";

//配列の中に一つでも要素が含まれているかを判定する関数
export const isIncludes = (arr:string[], target:string[]) => arr.some(el => target.includes(el));

//配列の中に全ての要素が含まれているかを判定する関数
export const isAllIncludes = (arr:string[], target:string[]) => arr.every(el => target.includes(el));

//Markers型の配列を受け取り、現在地に近い順にソートする関数
export const sortMarkersAtCenter = (markers: MakerData[], currentPosition: Position) => {
    function haversine(lat1: number, lon1: number, lat2: number, lon2: number): number {
      const R = 6371; // Radius of the earth in km
      const dLat = (lat2 - lat1) * (Math.PI / 180);
      const dLon = (lon2 - lon1) * (Math.PI / 180);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c; // Distance in km
      return distance;
    }
  
    const centerLat = currentPosition.lat;
    const centerLng = currentPosition.lng;
  
    function compareFunc(a: MakerData, b: MakerData): number {
      const distanceA = haversine(centerLat, centerLng, a.latitude, a.longitude);
      const distanceB = haversine(centerLat, centerLng, b.latitude, b.longitude);
      return distanceA - distanceB; // 中心からの距離で昇順ソート
    }
  
    return markers.sort(compareFunc);
  };
  

//現在地周辺にランダムな位置のMarkerを生成する関数（モックアプリ用なのでもう使わない）
export const randomMarker = (marker:MakerData,currentPosition:Position):MakerData=>{
    
    //ランダム処理
    let lat = currentPosition.lat 
    let lng = currentPosition.lng
    const randomLat = Math.random()*0.003;
    const randomLng = Math.random()*0.003;
    if(randomLat > randomLng){
    lat = lat + randomLat
    lng = lng + randomLng
    }else{
    lat = lat - randomLat
    lng = lng - randomLng
    }
    return {
        ...marker,
        latitude: lat,
        longitude: lng,
    };
};

export const copyTextToClipboard = async (text:string) => {
    await navigator.clipboard.writeText(text)
    .then(function() {
    }, function(err) {
    });
}

export const getCurrentPosition = (): Promise<{ lat: number, lng: number }> => {
  return new Promise<{ lat: number, lng: number }>((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(position => {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;
      resolve({ lat: lat, lng: lng });
    }, err => {
      reject(err);
    });
  });
}

export const getDistance = (lat1:number, lng1:number, lat2:number, lng2:number) => {
  function haversine(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Radius of the earth in km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in km
    return distance * 0.01;
  }
  const distance = haversine(lat1, lng1, lat2, lng2);
  return distance;
}